import axios from 'axios'
import { getEPreferencesApi, WITH_CREDENTIALS_CONFIG } from './constants'

export const getEPreferences = (accountNumber: string) =>
  axios.get(getEPreferencesApi(accountNumber), WITH_CREDENTIALS_CONFIG)
